if (!customElements.get('region-pairing')) {
  customElements.define(
    'region-pairing',
    class RegionPairing extends HTMLElement {
      connectedCallback() {
        this.nameTarget = this.querySelector('[data-region-name]');
        this.cheeseTarget = this.querySelector('[data-region-cheese]');
        this.drinkTarget = this.querySelector('[data-region-drink]');
        this.productsTarget = this.querySelector('[data-region-products]');
        this.abortController = null;

        this.addEventListener('click', (event) => {
          const regionButton = event.target.closest('[data-region]');
          if (!regionButton || !this.contains(regionButton)) return;
          this.selectRegion(regionButton);
        });

        const initialRegion = this.querySelector('[data-region].is-active') || this.querySelector('[data-region]');
        if (initialRegion) this.selectRegion(initialRegion);
      }

      async selectRegion(button) {
        this.querySelectorAll('[data-region]').forEach((region) => {
          const isSelected = region === button;
          region.classList.toggle('is-active', isSelected);
          region.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });

        this.nameTarget.textContent = button.dataset.region;
        this.cheeseTarget.textContent = button.dataset.cheese;
        this.drinkTarget.textContent = button.dataset.drink;
        await this.loadProducts(
          [button.dataset.productUrl, button.dataset.locationUrl],
          button.dataset.region
        );
      }

      async loadProducts(urls, regionName) {
        if (this.abortController) this.abortController.abort();
        this.abortController = new AbortController();
        this.productsTarget.setAttribute('aria-busy', 'true');
        this.productsTarget.innerHTML = `<p class="region-pairing__status">Loading products from ${regionName}…</p>`;

        try {
          const pages = await Promise.all(
            urls.filter(Boolean).map(async (url) => {
              const response = await fetch(url, {
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                signal: this.abortController.signal,
              });
              if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
              return new DOMParser().parseFromString(await response.text(), 'text/html');
            })
          );

          const seenProductIds = new Set();
          const productItems = pages
            .flatMap((page) => Array.from(page.querySelectorAll('li.js-pagination-result')))
            .filter((item) => {
              const productCard = item.querySelector('.card--product');
              const productId = productCard?.dataset.productId;
              if (!productCard || !productId || seenProductIds.has(productId)) return false;
              seenProductIds.add(productId);
              return true;
            })
            .slice(0, 5);

          if (productItems.length === 0) {
            this.productsTarget.innerHTML = `<p class="region-pairing__status">No products tagged for ${regionName} are currently available.</p>`;
          } else {
            const productMarkup = productItems.map((item) => item.outerHTML).join('');
            this.productsTarget.innerHTML = `<ul class="grid grid-cols-1 gap-card" role="list">${productMarkup}</ul>`;

            if (typeof initLazyImages === 'function') {
              initLazyImages();
            }
          }
          this.productsTarget.removeAttribute('aria-busy');
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.productsTarget.innerHTML = '<p class="region-pairing__status">Product information is temporarily unavailable.</p>';
          this.productsTarget.removeAttribute('aria-busy');
        }
      }
    }
  );
}
